/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum ErrorCodes {
  INVALID_USER_NAME_OR_PASSWORD = 1000,
  REPEATED_INCORRECT_PASSWORD = 1001,
  USER_IS_INACTIVE = 1002,
  USER_IS_LOCKED = 1003,
  UNKNOWN_USER_ROLE = 1004,
  USER_NAME_ALREADY_EXIST = 1005,
  USER_LDAP_REJECTED = 10010,
  USER_AZUREAD_REJECTED = 10011,
  LOCAL_USER_LOGIN_NOT_ALLOWED = 1026,
  INVALID_AUTHENTICATION_GROUP_MAPPING = 1027,
  LDAP_MACHINE_IS_NOT_AVAILABLE = 1028,
  TOO_MANY_CSV_REQUESTS = 1029,
}
